// GLOBAL TODOS:
// - Properly scope UI to roles
import '@/scss/style.scss';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin, type VueQueryPluginOptions } from '@tanstack/vue-query';

import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { auth } from './plugins/auth';
import { initDatadogRum } from '@marketspark/shared-ui/utils/datadog-rum';

const app = createApp(App);

const {
  VITE_EIKON_DATADOG_APPLICATION_ID,
  VITE_EIKON_DATADOG_CLIENT_TOKEN,
  VITE_EIKON_ENABLE_DATADOG_RUM,
  VITE_ENV,
  VITE_APP_VERSION,
} = import.meta.env;

initDatadogRum({
  applicationId: VITE_EIKON_DATADOG_APPLICATION_ID,
  clientToken: VITE_EIKON_DATADOG_CLIENT_TOKEN,
  service: 'eikon',
  enabled: VITE_EIKON_ENABLE_DATADOG_RUM === 'true',
  env: VITE_ENV,
  version: VITE_APP_VERSION,
});

const vQueryOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  },
};

app.use(createPinia());
app.use(VueQueryPlugin, vQueryOptions);
app.use(router);
app.use(auth);
app.use(vuetify);

app.mount('#app');
